module.exports = __webpack_public_path__ + "img/review-empty-xl.3ee853c4.svg";